import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/membershipOrder';

const orderByOrderSn = (systemSource, merchantId, orderSn) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/order-by-sn/${orderSn}`
		)
	);
};

const refundOrder = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/refund/order`),
		data
	);
};

export default {
	orderByOrderSn,
	refundOrder,
};
